import {useState} from 'react';
import {ThemeProvider,Container, Box, Typography,  Paper} from '@mui/material';

import theme from "../../theme";

import ItemProduct from "./ItemProduct";

import { motion } from 'framer-motion';

import honeyProducts from '../honeys/honeyProducts';

const fadeVariant = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const fadeInVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: 'easeOut' },
  },
};

const productVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: i * 0.2, 
      ease: 'easeOut'
    }
  }),
};

const Products = () => {
 
     const [products, setProducts] = useState(honeyProducts);

    return(

        <ThemeProvider theme={theme}>

             {/* <motion.div
                            
                            variants={fadeInVariant}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }} // 30% widoczne = start animacji
                            > */}
            <Container 
            // maxWidth= {xs:'20px' ,sm:'30px'}
            
                       component={Paper}
                       id='our_honeys'
                       sx={{
                           marginTop: '100px',
                           padding:'30px 0',
                           maxWidth:  {xs:'380px' ,sm:'700px', md:'900px',lg:'1200px',xl:'1300px'}
                  
                       }}>
                <Box >
                    <Typography  variant='h3' sx={{

                        fontSize: { xs: 20, sm:30 },
                        fontWeight: 700,
                        textAlign:'center',
                        paddingBottom:'50px'
                    }}>Nasze miody</Typography>
                </Box>

                <Box sx={{
                    display:'flex',
                    flexDirection: 'column',
                    // flexGrow: 1,
                    // flexWrap: 'wrap',
                    gap: '20px',
                    // margin: '0 auto',
                    margin:  {xs:'10px' ,sm:'10px', md:'20px',lg:'20px',xl:'20px'}
                }}>
                        {products.map((product,index) => (

                            <motion.div
                                key={product.id}
                                custom={index}
                                variants={productVariant}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.2 }}
                            >

                                <ItemProduct
                                    key={product.id}
                                    product={product}
                                />
                            </motion.div>
                        ))}
                </Box>

            </Container >
            {/* </motion.div> */}
        </ThemeProvider >
    )
}

export default Products;